<template>
    <div class="select">
        <div class="select__wrapper">
            <multiselect v-model="selected"
                         :options="options"
                         :multiple="true"
                         :searchable="false"
                         :close-on-select="closeOnSelected"
                         :clear-on-select="false"
                         :preserve-search="false"
                         selected-label="Выбран"
                         select-label="Корпус"
                         deselect-label=""
                         delete-label=""
                         @close="selectClose"
                         placeholder="Корпус"
                         label="title"
                         track-by="name"
            >
                <template slot="selection"
                          slot-scope="{ values, search, isOpen }"
                >
                <span class="multiselect__single"
                   v-if="values.length && !isOpen && !isStep">Корпусов выбрано: {{ values.length }}
                </span>
                <span class="multiselect__single"
                   v-if="values.length && !isOpen && isStep === 'parking'">{{ values[0].title }} корпус
                </span>
                </template>
            </multiselect>

        </div>
    </div>

</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import {mapActions, mapGetters} from 'vuex';
import Multiselect from 'vue-multiselect';
import Observer from 'common/scripts/observer';

const observer = new Observer();

export default {
    components: {
        Multiselect
    },

    props: ['list', 'closeOnSelect', 'isStep'],

    data() {
        return {
            selected       : [],
            options        : [],
            isInit         : false,
            closeOnSelected: false
        };
    },

    watch: {
        list() {
            this.setList();
        },

        // утанавливаем выбранные здания для vue-мультиселекта
        selectedObjects() {
            this.selected = [];
            this.selected = this.selectedObjects;
        }
    },

    mounted() {
        this.setList();
    },

    methods: {
        ...mapActions(['closeSelected']),

        setList() {
            if (this.list) {
                this.options = [];
                this.closeOnSelected = this.closeOnSelect;

                for (const item in this.list) {
                    if ({}.hasOwnProperty.call(this.list, item)) {
                        const rv = {};

                        // eslint-disable-next-line no-undefined
                        if (this.list[item] !== undefined) {
                            rv[item] = this.list[item];
                            this.options.push(rv[item]);
                        }
                    }
                }
            }
        },

        selectClose() {
            // при закрытии селекта обновляем данные в сторе
            const arr = [];

            for (const item in this.selected) {
                if ({}.hasOwnProperty.call(this.selected, item)) {
                    arr.push(this.selected[item].id);
                }
            }

            observer.publish('selectorChange', {item: arr[0]});

            this.closeSelected(arr);
            this.$emit('selectric-select');
        }
    },
    computed: {
        ...mapGetters({
            selectedBuildings: 'GET_SELECTED_BUILDINGS',
            selectedObjects  : 'GET_SELECTED_OBJECTS'
        })
    }
};
</script>


